import { defineMessages } from 'react-intl'

import { CALL_STATUS } from './constants'

export const callStatusMessages = defineMessages({
  [CALL_STATUS.VOICEMAIL]: {
    id: 'spanish.booking.registerSupportInteraction.voicemail',
    defaultMessage: 'Buzón'
  },
  [CALL_STATUS.HUNG_UP]: {
    id: 'spanish.booking.registerSupportInteraction.hungUp',
    defaultMessage: 'Colgó'
  },
  [CALL_STATUS.WRONG_NUMBER]: {
    id: 'spanish.booking.registerSupportInteraction.wrongNumber',
    defaultMessage: 'Número equivocado'
  },
  [CALL_STATUS.BUSY_NUMBER]: {
    id: 'spanish.booking.registerSupportInteraction.busyNumber',
    defaultMessage: 'Número ocupado'
  },
  [CALL_STATUS.UNAVAILABLE_NUMBER]: {
    id: 'spanish.booking.registerSupportInteraction.unavailableNumber',
    defaultMessage: 'Número no disponible'
  },
  [CALL_STATUS.NON_EXISTENT_NUMBER]: {
    id: 'spanish.booking.registerSupportInteraction.nonExistentNumber',
    defaultMessage: 'Número no existe'
  },
  [CALL_STATUS.ATTENDANCE_CONFIRMED]: {
    id: 'spanish.booking.registerSupportInteraction.attendanceConfirmed',
    defaultMessage: 'Confirma asistencia'
  },
  [CALL_STATUS.CANCELLATION]: {
    id: 'spanish.booking.registerSupportInteraction.cancellation',
    defaultMessage: 'Cancelación'
  },
  [CALL_STATUS.SERVICE_CHANGE]: {
    id: 'spanish.booking.registerSupportInteraction.serviceChange',
    defaultMessage: 'Cambio horario'
  }
})
